import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { RootState } from '../store'

// For the record, I don't like this name, suggestions welcome

type InteractivityState = {
    highlightEventItems: boolean
    availableEventIdsForSetup: { [setupId: string]: string[] }
}

const initialState: InteractivityState = {
    highlightEventItems: false,
    availableEventIdsForSetup: {}
}

const slice = createSlice({
    name: "interactivity",
    initialState,
    reducers: {

        setAvailableEventIdsForSetup: (state, action: PayloadAction<{
            setupId: string
            availableEventIds: string[]
        }>) => {
            const { availableEventIds, setupId } = action.payload

            state.highlightEventItems = true
            state.availableEventIdsForSetup[setupId] = availableEventIds
        },

        clearAvailableEventIdsForSetup: (state, action: PayloadAction<{ setupId: string }>) => {
            state.highlightEventItems = false
            delete state.availableEventIdsForSetup[action.payload.setupId]
        }

    }
})

function selectors(state: InteractivityState) {
    return {

        getEventStateForSetup(setupId: string, eventId: string): {
            valid: boolean | undefined
            invalid: boolean | undefined
        } {

            if (state.highlightEventItems === false) {
                return { valid: undefined, invalid: undefined }
            }

            const setupEvents = state.availableEventIdsForSetup[setupId]

            if (setupEvents == null) {
                return { valid: undefined, invalid: undefined }
            }

            let available = state.availableEventIdsForSetup[setupId].filter(e => e === eventId).length === 1

            return {
                valid: available,
                invalid: available === false
            }
        },

    }
}

export const InteractivityReducer = slice.reducer
export const InteractivityActions = slice.actions

export function useInteractivitySelectors(): ReturnType<typeof selectors> {
    const state = useSelector<RootState, InteractivityState>(s => s.interactivity)
    return selectors(state)
}
